module.exports = __webpack_public_path__ + "img/A57-20190408_05.2f59178e.jpg";